const employeeBulkUploadColumns = [
  {
    field: "",
    key: "fullname",
    title: "#",
    align: "center",
    fixed: true,
    width: 50,
    renderBodyCell: ({ rowIndex }) => ++rowIndex
  },

  {
    field: "EmployeeNo",
    key: "EmployeeNo",
    title: "Employee No",
    align: "left",
    fixed: true,
    width: 120
  },

  {
    field: "Username",
    key: "Username",
    title: "Username",
    headerAlign: "left",
    align: "left",
    width: 180
  },

  {
    field: "FullName",
    key: "FullName",
    title: "Full Name",
    headerAlign: "left",
    align: "left",
    width: 200
  },

  {
    field: "Gender",
    key: "Gender",
    title: "Gender",
    align: "center",
    width: 80,
    renderBodyCell: ({ row }) => (row.Gender ? row.Gender[0] : "...."),
  },

  {
    field: "RoleName",
    key: "RoleName",
    title: "Role Name",
    align: "left",
    width: 150
  },

  {
    field: "WorkEmail",
    key: "WorkEmail",
    title: "Work Email",
    align: "left",
    width: 250
  },
  
  {
    field: "WorkPhoneNumber",
    key: "WorkPhoneNumber",
    title: "Work Phone Number",
    align: "center",
    width: 150
  },

  {
    field: "JobGradeName",
    key: "JobGradeName",
    title: "Job Grade Name",
    sortable: true,
    headerAlign: "left",
    align: "left",
    width: 150
  },

  {
    field: "DateOfJoining",
    key: "DateOfJoining",
    title: "Date Of Joining",
    width: 130
  },

  {
    field: "CanSignIn",
    key: "CanSignIn",
    title: "Can Sign In",
    align: "center",
    headerAlign: "center",
    width: 100,
    renderBodyCell: ({ row }) => row.CanSignIn ? "YES" : "NO"
  },

  {
    field: "EmploymentStatusName",
    key: "status",
    title: "Status",
    width: 150
  }
];

export default employeeBulkUploadColumns;
